import { Link } from 'react-router-dom';
import EventThumbnail from '../../../../../../Event/EventThumbnail';
import { LabeledValue } from '../../../../../../../core/components';
import { useMediaQuery } from '@mui/material';
import theme from '../../../../../../../theme';
import { useTranslation } from 'react-i18next';
import styles from './analyticsRow.module.scss';
import { fromUnitAmount } from '../../../../../../../utils/unitAmountHelper';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import AnalyticsTrendIcon from './components/AnalyticsTrendIcon/AnalyticsTrendIcon';

const AnalyticsRow = ({ video, currencyFormatter }) => {
    const isTablet = useMediaQuery(theme.breakpoints.down('tablet'));
    const { t } = useTranslation();

    return (
        <div className={styles.root}>
            <Link to={`/watch/${video.id}`}>
                <EventThumbnail
                    borderRadius={'12px'}
                    event={video}
                    width={isTablet ? 70 : 126}
                    height={isTablet ? 70 : 84}
                />
            </Link>
            <div className={styles.column}>
                <Link to={`/watch/${video.id}`}>
                    <LabeledValue value={video.title} label={video.description} />
                </Link>
            </div>

            {isTablet && (
                <div className={styles.column}>
                    <AnalyticsTrendIcon trend={video.trend} />
                </div>
            )}

            <div className={styles.statistics}>
                <div className={styles.column}>
                    <LabeledValue
                        value={currencyFormatter(
                            video.currency.toUpperCase(),
                            fromUnitAmount(video.total)
                        )}
                        label={t('TotalEarnings')}
                    />
                </div>
                <div className={styles.column}>
                    <LabeledValue value={video.count} label={t('Streams')} />
                </div>
            </div>

            {!isTablet && (
                <div className={styles.column}>
                    <AnalyticsTrendIcon trend={video.trend} />
                </div>
            )}
        </div>
    );
};

export default AnalyticsRow;
